export class StartSession {
    userId: number;
    tariffId: number;
    reason: string;
    chargePointEVSEId: number;
    kwh: number;
    minutes : number;
    amount : number;
}
